import React, { Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  FormText,
} from "reactstrap";

class Business extends Component{
  constructor(props) {
    super(props);
    this.state = {
      salary: '',
      companyName: '',
    }
  }


  render() {
    return (
      <FormGroup row>
      <Col md="1">
        <Label htmlFor="text-input">Income (per month)<span style={{color:"red"}}>*</span></Label>
      </Col>
      <Col md="3">
        <InputGroup className="input-prepend">
              <InputGroupAddon className = "rupee-business-sym"><i className="fa fa-inr"></i></InputGroupAddon>
            <Input type="text" id="text-input" name="salary" placeholder="" className={this.props.salaryValid} value={this.props.salary} onChange={(event) => this.props.handleUserInput(event)} onBlur={(event) => this.props.handleUserInput(event)}/>
        </InputGroup>
      </Col>
      <Col md="1">
        <Label htmlFor="textarea-input">Company Name<span style={{color:"red"}}>*</span></Label>
      </Col>
      <Col md="3">
       <div className="companies_w">
        <Input type="text" id="text-input" name="companyName" placeholder=""  value={this.props.companyName} onChange={(event) => this.props.handleUserInput(event)} onFocus={(event) => this.props.showcompanylist(event)}/>
            {(this.props.showcompanyfilter == true && this.props.companies != [])? <div className="companiesfilter">
                <ul>
                 {this.props.companies.map((data,key) =>
                 <li key={key} onClick={(event) => this.props.companyclick(event)} >{data.company_name}</li>
                      )}
                </ul>
                </div>
            :""

                }
                </div>
      </Col>
      </FormGroup>
    )
  }
}

export default Business;



// WEBPACK FOOTER //
// ./src/views/Pages/LoanForm/Business.js